/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import type { Toast } from 'reducers/toasts';
import SuccessToast from 'components/SuccessToast.jsx';
import ErrorToast from 'components/ErrorToast.jsx';
import { CSSTransitionGroup } from 'react-transition-group';
import { bindActionCreators } from 'redux';
import { remove } from 'reducers/toasts';
import { List } from 'immutable';

import './styles/ToastsContainer.scss';

const MINIMUM_TIMEOUT = 1000;
const TIME_PER_CHARACTER = 100;

function calculateTimeout(toast: Toast): number {
  return MINIMUM_TIMEOUT + toast.text.length * TIME_PER_CHARACTER;
}

type Props = {
  toasts: List<Toast>,
  remove: (toast: Toast) => any,
};

class ToastsContainer extends React.Component<Props> {
  componentWillReceiveProps(nextProps: Props) {
    const newToast = nextProps.toasts.last();
    const toasts = nextProps.toasts.slice(0, -1);

    // Because we are going to clear all but the new toast
    // we can clear this timeout, no problemo.
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    // Clear all the toasts but the new one.
    toasts.forEach(toast => this.props.remove(toast));

    // clear the new toast after a little time.
    if (newToast) {
      this.timeout = setTimeout(() => this.props.remove(newToast), calculateTimeout(newToast));
    }
  }

  timeout: any;

  renderToast(toast: Toast) {
    const Component = toast.kind === 'success' ? SuccessToast : ErrorToast;

    return <Component key={toast.uuid}>{toast.text}</Component>;
  }

  render() {
    return (
      <div className="ToastsContainer">
        <CSSTransitionGroup
          transitionAppear
          transitionName="toasts"
          transitionEnterTimeout={500}
          transitionAppearTimeout={500}
          transitionLeaveTimeout={500}>
          {this.props.toasts.toArray().map(toast => this.renderToast(toast))}
        </CSSTransitionGroup>
      </div>
    );
  }
}

function mapStateToProps(state: Object) {
  return {
    toasts: state.toasts,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ remove }, dispatch);
}

export { ToastsContainer };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToastsContainer);
